import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { FaEye } from "react-icons/fa"
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap"
import { fetchData } from "utils/Common_api_functions"

const AuditLogs = () => {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(false)
  const [logModal, setLogModal] = useState(false)
  const [selectedLog, setSelectedLog] = useState({})

  useEffect(() => {
    getLogs()
  }, [])

  async function getLogs() {
    const APIdata = await fetchData(setLoading, "logs")
    if (APIdata?.success) setLogs(APIdata?.data)
  }

  const parsedDescription = (() => {
    try {
      return JSON.parse(selectedLog?.description || "{}")
    } catch (e) {
      return null
    }
  })()

  const renderValue = value => {
    if (value === null || value === undefined) {
      return <span style={{ color: "#94a3b8", fontStyle: "italic" }}>null</span>
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return (
          <span
            style={{
              background: "#f1f5f9",
              borderRadius: "5px",
              padding: "2px 8px",
              fontSize: "12px",
              color: "#94a3b8",
            }}
          >
            Empty
          </span>
        )
      }
      if (typeof value[0] === "object" && value[0] !== null) {
        const columns = [...new Set(value.flatMap(obj => Object.keys(obj)))]
        return (
          <div style={{ overflowX: "auto", marginTop: "6px" }}>
            <Table
              bordered
              size="sm"
              style={{ fontSize: "12px", marginBottom: 0 }}
            >
              <thead style={{ background: "#f8faff" }}>
                <tr>
                  <th>#</th>
                  {columns.map(col => (
                    <th key={col} style={{ whiteSpace: "nowrap" }}>
                      {col.replace(/([A-Z])/g, " $1").trim()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {value.map((row, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    {columns.map(col => (
                      <td key={col}>{renderValue(row[col])}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )
      }
      return (
        <div className="d-flex flex-wrap gap-1" style={{ marginTop: "4px" }}>
          {value.map((item, i) => (
            <span
              key={i}
              style={{
                background: "#f1f5f9",
                borderRadius: "6px",
                padding: "2px 10px",
                fontSize: "12px",
                color: "#475569",
              }}
            >
              {String(item)}
            </span>
          ))}
        </div>
      )
    }

    if (typeof value === "object") {
      return (
        <div
          style={{
            marginTop: "6px",
            paddingLeft: "12px",
            borderLeft: "2px solid #ede9fe",
          }}
        >
          {renderObject(value)}
        </div>
      )
    }

    if (typeof value === "boolean") {
      return (
        <span
          style={{
            background: value ? "#e8f5e9" : "#fdecea",
            color: value ? "#2e7d32" : "#EF5350",
            borderRadius: "6px",
            padding: "2px 10px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {value ? "true" : "false"}
        </span>
      )
    }

    if (typeof value === "number") {
      return (
        <span
          style={{
            background: "#f0f4ff",
            color: "#6C63FF",
            borderRadius: "6px",
            padding: "2px 10px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {value}
        </span>
      )
    }

    return <span style={{ fontSize: "13px" }}>{String(value)}</span>
  }

  const renderObject = obj => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {Object.entries(obj).map(([key, val]) => {
          const isNested =
            typeof val === "object" && val !== null && !Array.isArray(val)
          const isArrayOfObjects =
            Array.isArray(val) && val.length > 0 && typeof val[0] === "object"

          return (
            <div key={key}>
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: isNested || isArrayOfObjects ? "#6C63FF" : "#475569",
                  marginBottom: isNested || isArrayOfObjects ? "4px" : "0",
                  display: "flex",
                  alignItems:
                    isNested || isArrayOfObjects ? "center" : "baseline",
                  gap: "8px",
                }}
              >
                <span>
                  {key.replace(/([A-Z])/g, " $1").trim()}
                  {(isNested || isArrayOfObjects) && (
                    <span style={{ color: "#c4b5fd", marginLeft: "2px" }}>
                      /
                    </span>
                  )}
                </span>
                {!isNested && !isArrayOfObjects && renderValue(val)}
              </div>

              {(isNested || isArrayOfObjects) && (
                <div
                  style={{
                    paddingLeft: "14px",
                    borderLeft: "2px solid #ede9fe",
                  }}
                >
                  {renderValue(val)}
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Dashboard" breadcrumbItem="Sheet Logs" />
      <Card>
        <CardBody>
          <Table striped responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Action</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {logs?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.action}</td>
                  <td>
                    <Button
                      className="btn-blue"
                      onClick={() => {
                        setSelectedLog(item)
                        setLogModal(true)
                      }}
                    >
                      <FaEye />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Modal isOpen={logModal} size="lg" scrollable>
        <ModalHeader toggle={() => setLogModal(false)}>Log Details</ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          {parsedDescription ? (
            <div
              style={{
                background: "#f8faff",
                borderRadius: "10px",
                border: "1px solid #ede9fe",
                overflow: "hidden",
                padding : "10px"
              }}
            >
              {renderObject(parsedDescription)}
            </div>
          ) : (
            <p style={{ fontSize: "13px", color: "#64748b" }}>
              {selectedLog?.description || "No description available."}
            </p>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AuditLogs
